var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMercado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.688.814C.688.503.939.25 1.25.25h1.799c.527 0 .984.366 1.098.881l.18.807h10.021c.708 0 1.24.645 1.105 1.34l-1.098 5.625c-.103.528-.566.91-1.104.91H6.076l.127.57a1.69 1.69 0 011.42 1.117h3.285a1.688 1.688 0 110 1.125H7.623A1.688 1.688 0 115.11 10.65L3.049 1.376H1.25A.563.563 0 01.687.814zm5.138 7.875l-1.25-5.625h9.772l-1.097 5.625H5.826zm6.112 3.375a.562.562 0 101.124 0 .562.562 0 00-1.124 0zm-5.344 0a.562.562 0 11-1.125 0 .562.562 0 011.125 0zm1.125-7.875a.563.563 0 00-1.125 0v3.375a.563.563 0 001.125 0V4.189zm1.828-.563c.31 0 .562.252.562.563v3.375a.563.563 0 01-1.125 0V4.189c0-.311.252-.563.563-.563zm2.953.563a.562.562 0 10-1.125 0v3.375a.562.562 0 101.125 0V4.189z",
    fill: "#E60014"
  })));
}

export default SvgMercado;